export const DALLAS_TEXT_ALIGN_OPTIONS = [
  'start',
  'center',
  'end',
  'justify',
  'inherit',
] as const;

export type DallasTextAlign = (typeof DALLAS_TEXT_ALIGN_OPTIONS)[number];

export const DALLAS_TEXT_AS_OPTIONS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'div',
  'small',
  'span',
  'li',
  'address',
  'caption',
  'abbr',
] as const;

export type DallasTextAs = (typeof DALLAS_TEXT_AS_OPTIONS)[number];

export const DALLAS_TEXT_COLOR_OPTIONS = [
  'dark',
  'darkGray',
  'light',
  'lightGray',
  'brand',
  'info',
  'success',
  'error',
  'warning',
] as const;

export type DallasTextColor = (typeof DALLAS_TEXT_COLOR_OPTIONS)[number];

export const DALLAS_TEXT_COLOR_CLASSNAME_SEGMENTS: Readonly<
  Record<DallasTextColor, string>
> = {
  dark: 'dark',
  darkGray: 'dark-gray',
  light: 'light',
  lightGray: 'light-gray',
  brand: 'brand',
  info: 'info',
  success: 'success',
  error: 'error',
  warning: 'warning',
};

export const DALLAS_TEXT_VARIANT_OPTIONS = [
  'headerCondensedXXL',
  'headerCondensedXL',
  'headerCondensedL',
  'headerCondensedM',
  'headerCondensedS',
  'headerRegularXL',
  'headerBoldXL',
  'headerRegularL',
  'headerBoldL',
  'headerRegularM',
  'headerBoldM',
  'headerRegularS',
  'headerBoldS',
  'body',
  'captionL',
  'captionM',
  'captionS',
  'captionXS',
] as const;

export type DallasTextVariant = (typeof DALLAS_TEXT_VARIANT_OPTIONS)[number];
